import { useQuery } from "@tanstack/react-query";
import { PowerStatApi } from "../routes/powerStat";
import { apiLogger } from "../Utils/logger";

export const useGetPowerStats = (params) => {
  return useQuery({
    queryKey: ["powerStats"],
    queryFn: async () => {
      try {
        apiLogger.apiRequest("GET", "/user/power-score-stats");
        const response = await PowerStatApi.getPowerStats(params);
        apiLogger.apiResponse("GET", "/user/power-score-stats", response, 200);

        // Extract the data from response.data.data (following the old pattern)
        return response?.data || response;
      } catch (error) {
        apiLogger.apiError(
          "GET",
          "/user/power-score-stats",
          error,
          error.response?.status,
        );
        throw error;
      }
    },
    enabled: true,
    retry: 1,
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};
